import { IAppState } from "../../../app/appTypes"
import { ITenantConfigContextState } from "../../../features/tenantConfig/state/tenantConfigTypes"

// For use when TenantConfigProvider cannot be used eg. report
export const getTenantConfig = (state: IAppState): ITenantConfigContextState => {
  return state.tenantConfig
}
